var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "legend-border bg-white scroll-Container legend-scroll",
      style: _vm.layerLegendMaxHeight,
    },
    [
      _c(
        "b-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            [
              _c(
                "span",
                {
                  staticClass: "capitalize layer-name-header",
                  attrs: { id: "modifiedLayerName" },
                },
                [_vm._v("\n        " + _vm._s(_vm.modifiedName) + "\n      ")]
              ),
              _vm._v(" "),
              _c("fa", {
                staticClass: "float-right clickable",
                attrs: {
                  id: "closeLayerLegendElement",
                  title: "Close Legend",
                  icon: ["fas", "window-close"],
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("closeLegend")
                  },
                },
              }),
              _vm._v(" "),
              _c("fa", {
                staticClass: "float-right clickable mx-1",
                attrs: {
                  id: "minOrMaxLayerLegendElement",
                  title: _vm.legendMinimized
                    ? "Maximize Legend"
                    : "Minimize Legend",
                  icon: [
                    "fas",
                    _vm.legendMinimized ? "window-maximize" : "window-minimize",
                  ],
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit(
                      _vm.legendMinimized ? "maximizeLegend" : "minimizeLegend"
                    )
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { "no-gutters": "" } },
        [
          _c("b-col", [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.legendMinimized,
                  expression: "!legendMinimized",
                },
              ],
              attrs: {
                id: "imgLegend",
                height: _vm.height,
                width: _vm.width,
                src: _vm.legendImgSrc,
              },
              on: {
                load: function ($event) {
                  return _vm.getDimensions()
                },
              },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }